import React from "react"

import {
  BeakerIcon,
  CalendarIcon,
  CurrencyDollarIcon,
  UserIcon,
} from "@heroicons/react/24/solid"

import { Color } from "~tailwindui/types/enums"

import { path } from "~Tutor/TutorRoutes"
import ActionList from "~Tutor/components/ActionList"

export type YourAccountProps = { viewer }

const YourAccount: React.FC<YourAccountProps> = ({ viewer }) => {
  return (
    <ActionList
      title="Your Account"
      color={Color.Blue}
      listItems={[
        {
          icon: UserIcon,
          path: path("profileEdit"),
          text: "Edit Profile",
        },
        {
          icon: BeakerIcon,
          path: path("subjectBucketsIndex"),
          text: "Manage Air Tutors Subjects",
        },
        {
          icon: CurrencyDollarIcon,
          path: path("expensesIndex"),
          text: "View Expenses",
        },
        viewer.calendarId && {
          icon: CalendarIcon,
          path: `${path("dashboard")}?calendar_instructions=true`,
          text: "Link Your Google Calendar",
        },
      ]}
    />
  )
}

export default YourAccount
